const tr = {
  products: {
    attributes: {
      id: 'ID',
      ean: 'EAN',
      bin: 'BIN',
      description: 'Descrição',
      amount: 'Preço em centavos',
      currency: 'Código ISO da moeda',
      quantity: 'Quantidade',
      unlimited: 'Ilimitado',
      duration: 'Duração em dias',
      pack_type: 'Adicional',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
      name: 'Nome',
      is_sellable: 'Comercializável',
      pack: 'Pacote',
      has_membership_fee: 'Habilitar Taxa Adesão',
      membership_amount: 'Taxa de adesão em centavos',
    },
    extras: {
      create: 'Novo produto',
      edit: 'Editando produto',
      show: 'Visualizando produto',
      delete: 'Excluir produto',
    },
    defSingular: 'Produto',
    defPlural: 'Produto',
  },
};

export default tr;
